import toast from "react-hot-toast";

export const OK = "ok";

export const showErrorMessage = (message) => {
  toast.error(message, {
    duration: 4000,
  });
};

export const showSuccessMessage = (message) => {
  toast.success(message, {
    duration: 3000,
  });
};

export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const stripEmojis = (value = "") =>
  String(value)
    .replace(/\u00a0/g, " ")
    .replace(
      /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{200D}\u{FE0F}]/gu,
      "",
    )
    .replace(/\p{Extended_Pictographic}/gu, "")
    .replace(/\s+/g, " ")
    .trim();

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const sizesLabel = {
  "0-12M": "0-1 yrs",
  "0-5Months": "0-0.5 yrs",
  "6-12Months": "0.5-1 yrs",
  "12-23M": "1-2 yrs",
  "24-35M": "2-3 yrs",
  "36-47M": "3-4 yrs",
  "5Yrs": "4-6 yrs",
  "7Yrs": "6-8 yrs",
  "9Yrs": "8-10 yrs",
  "11Yrs": "10-12 yrs",
  "13Yrs": "12-13 yrs",
};

export const romperSixeLabel = {
  "0-5M": "0-5 months",
  "6-12M": "6-12 months",
};

export const shuffleArray = (array) => {
  const shuffled = [...array]; // Create a copy to avoid mutating original state
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
